import { render, staticRenderFns } from "./CareerDetails.vue?vue&type=template&id=2574cdf2&scoped=true&"
import script from "./CareerDetails.vue?vue&type=script&lang=js&"
export * from "./CareerDetails.vue?vue&type=script&lang=js&"
import style0 from "./CareerDetails.vue?vue&type=style&index=0&id=2574cdf2&lang=scss&scoped=true&"
import style1 from "./CareerDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574cdf2",
  null
  
)

export default component.exports